var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { QueryList } from '@angular/core';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { Router } from '@angular/router';
var QuestionAndAnswerComponent = /** @class */ (function () {
    function QuestionAndAnswerComponent(util, api, router) {
        this.util = util;
        this.api = api;
        this.router = router;
        this.notFoundResult = false;
        this.Search = null;
        this.faqList = [];
        this.categoryList = [];
        this.config = {};
        this.isCrisis = false;
        this.searchType = "k";
        this.filterWord = "";
        this.menuEnabled = false;
    }
    QuestionAndAnswerComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var thisTs, _a, menuList, thisMenu;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        thisTs = this;
                        this.util.ShowWaiting(true);
                        _a = this;
                        return [4 /*yield*/, this.api.get("master", "configuration")];
                    case 1:
                        _a.config = _b.sent();
                        if (this.config == null || this.config.length == 0) {
                            this.util.ErrorDialog("ไม่สามารถอ่านข้อมูลได้ กรุณาติดต่อเจ้าหน้าที่");
                            return [2 /*return*/];
                        }
                        this.isCrisis = this.config[0].dpa_crisisflag ? true : false;
                        return [4 /*yield*/, this.api.get("master", "customerPortalMenuSetting")];
                    case 2:
                        menuList = _b.sent();
                        thisMenu = this.util.getMenuObj(menuList, "03", this.isCrisis);
                        if (!thisMenu.show) {
                            this.util.ShowWaiting(false);
                            setTimeout(function () {
                                _this.router.navigate(["mainmenu/index"]);
                            }, 500);
                            return [2 /*return*/];
                        }
                        else {
                            this.menuEnabled = true;
                        }
                        return [4 /*yield*/, this.intiData()];
                    case 3:
                        _b.sent();
                        $('#filter').on('keyup', function () {
                            thisTs.filterQA();
                        });
                        $('input[type=search]').on('search', function () {
                            thisTs.filterQA();
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    QuestionAndAnswerComponent.prototype.intiData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var c;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.get("master", "knowledgebasecategory")];
                    case 1:
                        c = _a.sent();
                        this.categoryList = c.filter(function (k) {
                            return k.dpa_isfaq;
                        });
                        this.categoryList.forEach(function (c) { return __awaiter(_this, void 0, void 0, function () {
                            var _this = this;
                            var para, _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        para = "dpa_categoryid=" + c.dpa_kmcategoryid.toUpperCase() + "&dpa_publishstatus=true&dpa_isdisplayoncustomerportal=true&dpa_iscrisis=" + this.isCrisis.toString();
                                        _a = c;
                                        return [4 /*yield*/, this.api.get("master", "knowledgeBase", para)];
                                    case 1:
                                        _a.qList = _b.sent();
                                        if (c.qList != null && c.qList.length > 0) {
                                            c.qList.forEach(function (q) {
                                                if (q.attachfilelist != null && q.attachfilelist.length > 0) {
                                                    var baseUrl_1 = _this.util.baseUrl();
                                                    var att = q.attachfilelist.map(function (a) {
                                                        return '<a class="mr-3" target="_blank" href="' + baseUrl_1 + '/downloadFile?file=' + a.annotationid + '">' + a.filename + "</a>";
                                                    });
                                                    q.dpa_attch = '<label class="mr-3">ไฟล์แนบ:</label>' + att.join("");
                                                }
                                                else {
                                                    q.dpa_attch = '';
                                                }
                                            });
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        return [2 /*return*/];
                }
            });
        });
    };
    QuestionAndAnswerComponent.prototype.filterQA = function () {
        var _this = this;
        if (this.filterWord == null || this.filterWord.length < 3) {
            $(".question").each(function (index, element) {
                //let question = $(element).closest(".question")[0]
                $(element).removeClass("sr-only");
            });
            this.Search = "";
            this.notFoundResult = false;
            this.collapsAll();
        }
        else {
            var isFound_1 = false;
            if (this.searchType == "k") {
                $(".question").each(function (index, element) {
                    if ($(element).find(".content").attr("title").toLowerCase().includes(_this.filterWord.toLowerCase())) {
                        _this.Search = _this.filterWord;
                        _this.showFaq(element);
                        isFound_1 = true;
                    }
                    else {
                        var question = $(element).closest(".question")[0];
                        $(question).addClass("sr-only");
                    }
                });
            }
            else if (this.searchType == "c") {
                $(".question").each(function (index, element) {
                    if ($($(element).find(".collapsible-question")[0]).text().toLowerCase().includes(_this.filterWord.toLowerCase()) ||
                        $(element).find(".content").text().toLowerCase().includes(_this.filterWord.toLowerCase())) {
                        _this.Search = _this.filterWord;
                        _this.showFaq(element);
                        isFound_1 = true;
                    }
                    else {
                        var question = $(element).closest(".question")[0];
                        $(question).addClass("sr-only");
                    }
                });
            }
            else {
                $(".question").each(function (index, element) {
                    if ($(element).find(".content").attr("title").toLowerCase().includes(_this.filterWord.toLowerCase()) ||
                        $($(element).find(".collapsible-question")[0]).text().toLowerCase().includes(_this.filterWord.toLowerCase()) ||
                        $(element).find(".content").text().toLowerCase().includes(_this.filterWord.toLowerCase())) {
                        _this.Search = _this.filterWord;
                        _this.showFaq(element);
                        isFound_1 = true;
                    }
                    else {
                        var question = $(element).closest(".question")[0];
                        $(question).addClass("sr-only");
                    }
                });
            }
            this.notFoundResult = !isFound_1;
        }
    };
    QuestionAndAnswerComponent.prototype.collapsAll = function () {
        $(".collapsible").removeClass("active");
        $(".collapsible").next().slideUp();
        var body = $("html, body");
        body.stop().animate({ scrollTop: 0 }, 300, 'swing', function () {
        });
    };
    QuestionAndAnswerComponent.prototype.onParentClick = function (element) {
        element.classList.toggle("active");
        var content = element.nextElementSibling;
        $(content).slideToggle();
    };
    QuestionAndAnswerComponent.prototype.onBtnLabelClick = function (element) {
        var btn = $(element).closest("button")[0];
        btn.classList.toggle("active");
        var content = btn.nextElementSibling;
        $(content).slideToggle();
    };
    QuestionAndAnswerComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.faq.changes.subscribe(function (t) {
            _this.util.ShowWaiting(false);
        });
    };
    QuestionAndAnswerComponent.prototype.ngForRendred = function () {
        this.util.ShowWaiting(false);
    };
    QuestionAndAnswerComponent.prototype.showFaq = function (element) {
        var question = $(element).closest(".question")[0];
        $(question).removeClass("sr-only");
        var content = $(element).find(".content")[0];
        $(content).slideDown();
        var btn = $(element).find("button")[0];
        $(btn).addClass("active");
        setTimeout(function () {
            var parent = $(element).closest('.content')[0];
            $(parent).slideDown();
        }, 500);
    };
    return QuestionAndAnswerComponent;
}());
export { QuestionAndAnswerComponent };



// WEBPACK FOOTER //
// ./src/app/question-and-answer/question-and-answer.component.ts.pre-build-optimizer.js